import round from 'lodash/round';

export function getRoundedRating(rating = 0) {
	return round(rating, 1);
}

export function getRoundedStarRating(rating = 0) {
	return (rating < 0) ? 0 : getRoundedRating(rating);
}

export function formatRatingsSummary(value = 0) {
	//format score to one decimal place, removing trailing .
	if (value == null || Number.isNaN(value)) return null;
	const factor = 10;
	const truncated = Math.floor((value + Number.EPSILON) * factor) / factor;
	return Number.isInteger(truncated) ? String(truncated) : truncated.toFixed(1);
}